angular.module('impactx.panel').directive('ixProductGroupPanel', function () {
    return {
        restrict: 'EA',
        controller: 'ProductGroupPanelCtrl',
        controllerAs: 'productGroupPanelCtrl',
        scope: true,
        bindToController: {
            productGroup: "="
        },
        templateUrl: 'shared/panel/templates/productgroup.panel.tmpl.html'
    }
});